import { UserPermissions, CategoryAccess } from './api'

export type ProtocolPermissions = {
  isAdmin: boolean
  isCategoryManager: boolean
  isApprovingManager: boolean
  isViewer: boolean
  allAvailableCategories: number[]
  // categories
  canCreateCategory: boolean
  canDeleteCategory: boolean
  canEditCategoryById: (categoryId: number) => boolean
  // protocols
  canCreateProtocol: boolean
  canDeleteProtocol: boolean
  canArchiveProtocol: boolean
  canShareProtocol: boolean
  // archive
  canViewArchive: boolean
  canDeleteArchivedProtocol: boolean
  canRestoreProtocol: boolean
  // main manager
  canManageMainManagers: boolean
}

export function getProtocolPermissions(userPermissions: UserPermissions | null): ProtocolPermissions {
  const isAdmin = !!(userPermissions?.isAdmin || userPermissions?.isMainManager)

  const categoryAccess: CategoryAccess[] = Array.isArray(userPermissions?.allAvailableCategories)
    ? userPermissions!.allAvailableCategories!
    : []

  const getRoleInCategory = (categoryId: number): number | null =>
    categoryAccess.find(c => c.categoryId === categoryId)?.memberRoleId ?? null

  const isCategoryManager = !isAdmin && categoryAccess.some(c => c.memberRoleId === 1)
  const isApprovingManager = !isAdmin && categoryAccess.some(c => c.memberRoleId === 2)
  const isViewer = !isAdmin && categoryAccess.some(c => c.memberRoleId === 3)

  const allAvailableCategoryIds = categoryAccess.map(c => c.categoryId)

  return {
    isAdmin,
    isCategoryManager,
    isApprovingManager,
    isViewer,
    allAvailableCategories: allAvailableCategoryIds,

    canCreateCategory: isAdmin,
    canDeleteCategory: isAdmin,
    canEditCategoryById: (categoryId: number) => isAdmin || getRoleInCategory(categoryId) === 1,

    canCreateProtocol: isAdmin || categoryAccess.some(c => c.memberRoleId === 1 || c.memberRoleId === 2),
    canDeleteProtocol: isAdmin,
    canArchiveProtocol: isAdmin || isCategoryManager,
    canShareProtocol: isAdmin || isCategoryManager || isApprovingManager,

    canViewArchive: true,
    canDeleteArchivedProtocol: isAdmin,
    canRestoreProtocol: isAdmin || isCategoryManager,

    canManageMainManagers: isAdmin,
  }
}
